import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=52d1f57c&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=52d1f57c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d1f57c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d1f57c')) {
      api.createRecord('52d1f57c', component.options)
    } else {
      api.reload('52d1f57c', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=52d1f57c&scoped=true&", function () {
      api.rerender('52d1f57c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dXnwG13M0xhJ/JS/comp/PopupDialog.vue"
export default component.exports